const cards = [
  {
    icon: 'ri-focus-3-line',
    title: 'Our Mission',
    desc: 'We are dedicated to building iOS applications that genuinely improve people\'s digital lives — making security accessible and device performance effortless for every user.',
    accent: false,
  },
  {
    icon: 'ri-code-s-slash-line',
    title: 'Our Approach',
    desc: 'We follow modern, agile development methodologies with a relentless focus on quality, performance, and clean architecture — shipping products that stand the test of time.',
    accent: false,
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Our Vision',
    desc: 'To become a leading force in mobile security and optimisation software, continuously innovating to stay ahead of evolving user needs and emerging threats.',
    accent: true,
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-28 md:py-36 bg-stone-50">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-stone-400 mb-4">
            <span className="w-4 h-px bg-stone-300" />
            About Us
            <span className="w-4 h-px bg-stone-300" />
          </span>
          <h2 className="text-3xl md:text-5xl font-thin text-stone-900 leading-tight">
            Expert Team Developing<br />
            <em className="font-light not-italic text-stone-400">Premium iOS Solutions</em>
          </h2>
          <p className="mt-6 text-stone-500 text-base max-w-xl mx-auto leading-relaxed">
            Based in Slovenia, TUL d.o.o. brings together seasoned engineers and designers united by a passion for crafting exceptional mobile software.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cards.map((card) => (
            <div
              key={card.title}
              className={`rounded-2xl p-8 flex flex-col gap-5 transition-transform duration-300 hover:-translate-y-1 ${
                card.accent
                  ? 'bg-stone-900 text-white'
                  : 'bg-white text-stone-800'
              }`}
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${card.accent ? 'bg-white/10' : 'bg-stone-100'}`}>
                <i className={`${card.icon} text-xl ${card.accent ? 'text-white' : 'text-stone-600'}`} />
              </div>
              <div>
                <h3 className={`text-lg font-semibold mb-3 ${card.accent ? 'text-white' : 'text-stone-900'}`}>
                  {card.title}
                </h3>
                <p className={`text-sm leading-relaxed ${card.accent ? 'text-white/70' : 'text-stone-500'}`}>
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Stats row */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-2 gap-6 max-w-sm mx-auto md:max-w-none">
          {[
            { value: '2+', label: 'iOS Products' },
            { value: '100%', label: 'Privacy Focused' },
          ].map((stat) => (
            <div key={stat.label} className="text-center py-6 border-t border-stone-200">
              <div className="text-3xl font-thin text-stone-900 mb-1">{stat.value}</div>
              <div className="text-xs text-stone-400 uppercase tracking-widest">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
